<span *dialog-label>{{ headerLabel }}</span>

<ng-container *dialog-title>
  <h3 class="popup-title">{{ title }}</h3>
</ng-container>

<ng-container *dialog-content>
  <!-- Preview-Modus (Reihenfolge: Content, Bild — Klärung 23.03.2026) -->
  <ng-container *ngIf="mode$$() === 'preview'">
    <p class="popup-content">{{ content }}</p>

    <img
      *ngIf="previewData$$()?.imageUrl"
      [src]="previewData$$()?.imageUrl"
      class="popup-image"
      [alt]="title">
  </ng-container>

  <!-- User-Modus (Reihenfolge: Content, Bild — Klärung 23.03.2026) -->
  <ng-container *ngIf="mode$$() === 'user'">
    <p class="popup-content">{{ content }}</p>

    <img
      *ngIf="imageUrl"
      [src]="imageUrl"
      class="popup-image"
      [alt]="title">
  </ng-container>
</ng-container>

<ng-container *dialog-actions>
  <!-- Preview-Modus: einzelner Link -->
  <ng-container *ngIf="mode$$() === 'preview'">
    <jf-button
      *ngIf="previewData$$()?.linkUrl && previewData$$()?.linkLabel"
      [text]="previewData$$()!.linkLabel"
      variant="primary"
      icon="linkOut"
      iconPosition="right"
      (doClick)="handlePreviewLinkClick()">
    </jf-button>
  </ng-container>

  <!-- User-Modus: Links, Navigation -->
  <ng-container *ngIf="mode$$() === 'user'">
    <div class="popup-links">
      <jf-button
        *ngFor="let link of currentAnnouncement$$()?.links"
        [text]="link.label"
        variant="primary"
        icon="linkOut"
        iconPosition="right"
        (doClick)="handleLinkClick(link.url)">
      </jf-button>
    </div>

    <div class="popup-navigation" *ngIf="navigationVisible$$()">
      <jf-button
        text="< Zurück"
        variant="ghost"
        [disabled]="!hasPrev$$()"
        (doClick)="handlePrev()">
      </jf-button>

      <span class="popup-navigation-indicator" aria-live="polite">
        {{ currentIndex$$() + 1 }} von {{ totalCount$$() }}
      </span>

      <jf-button
        text="Weiter >"
        variant="ghost"
        [disabled]="!hasNext$$()"
        (doClick)="handleNext()">
      </jf-button>
    </div>

  </ng-container>
</ng-container>
